import { call, put } from 'redux-saga/effects';

import { requestForSaga } from 'utils/request/request';
import { requestCustomErrorMessage } from 'utils/request/requestCustomErrorMessage';
import { FETCH_ADVANCED } from './constants';

export function* fetchAdvancedSaga() {
  try {
    const settings = yield call(requestForSaga, {
      url: '/settings',
      method: 'GET',
    });
    yield put({
      type: `${FETCH_ADVANCED}_SUCCESS`,
      payload: settings,
    });
  } catch (e) {
    yield call(requestCustomErrorMessage, 'danger', e);
    throw e;
  }
}
